(function () {
  'use strict';

  // ── Configuration ──────────────────────────────────────────────────
  // REPLACE these after Pusher account + Cloudflare Worker are set up
  var CONFIG = {
    PUSHER_KEY: '3935619c173d43495711',        // Public key from Pusher dashboard
    PUSHER_CLUSTER: 'ap1',                 // Asia-Pacific (closest to AU)
    WORKER_URL: 'https://mode-support-proxy.modeauto.workers.dev',
    SESSION_TTL: 24 * 60 * 60 * 1000      // 24 hours
  };

  var STORAGE_KEY = 'mode_chat_session';
  var RESUME_QUERY_KEYS = [
    'mc_resume',
    'mc_session_id',
    'mc_conversation_id',
    'mc_session_token',
    'mc_email',
    'mc_name'
  ];

  // ── DOM refs ───────────────────────────────────────────────────────
  var bubble     = document.getElementById('modeChatBubble');
  var panel      = document.getElementById('modeChatPanel');
  var form       = document.getElementById('modeChatForm');
  var formError  = document.getElementById('modeChatFormError');
  var msgArea    = document.getElementById('modeChatMessages');
  var inputBar   = document.getElementById('modeChatInputBar');
  var inputField = document.getElementById('modeChatInput');
  var sendBtn    = document.getElementById('modeChatSend');
  var instantAnswersPanel    = document.getElementById('modeInstantAnswers');
  var instantAnswersList     = document.getElementById('modeInstantAnswersList');
  var instantAnswersGoChat   = document.getElementById('modeInstantAnswersGoChat');
  var instantAnswersMinimise = document.getElementById('modeInstantAnswersMinimise');
  var chatBackBtn            = document.getElementById('modeChatBack');
  var mentionProductBtn   = document.getElementById('modeChatMentionProduct');
  var minimiseBtn = document.getElementById('modeChatMinimise');
  var pageType   = panel ? panel.getAttribute('data-page-type') : '';
  var pageUrl    = panel ? panel.getAttribute('data-page-url') : '';

  var instantAnswersData = (function () {
    try {
      var el = document.getElementById('mode-instant-answers-data');
      return el ? JSON.parse(el.textContent) : [];
    } catch (e) { return []; }
  }());

  // ── State ──────────────────────────────────────────────────────────
  var session = null;   // { sessionId, conversationId, sessionToken, name, email, vehicle, createdAt }
  var pusher  = null;
  var channel = null;
  var sending = false;
  var includeProductUrl = false;
  var instantAnswersActive = false;  // true while back-arrow should be visible
  var pendingReadReceiptUrls = [];   // receipt URLs held while panel is closed

  // ── Business hours (Mon–Fri 9am–5pm AEST / UTC+10) ─────────────────
  function isWithinBusinessHours() {
    var now = new Date();
    // Get a date string in Sydney time, then parse day/hour numerically
    var sydneyStr = now.toLocaleString('en-CA', { timeZone: 'Australia/Sydney', hour12: false });
    // en-CA gives YYYY-MM-DD, HH:MM:SS — reliable across all browsers
    var datePart = sydneyStr.split(',')[0].trim();   // "2025-04-29"
    var timePart = sydneyStr.split(',')[1].trim();   // "12:01:00"
    var sydneyDate = new Date(datePart + 'T' + timePart);
    var day  = sydneyDate.getDay();   // 0=Sun, 1=Mon … 6=Sat
    var hour = sydneyDate.getHours(); // 0-23
    return day >= 1 && day <= 5 && hour >= 9 && hour < 17;
  }

  function updateOnlineStatus() {
    var online = isWithinBusinessHours();
    var dot  = document.getElementById('modeChatStatusDot');
    var text = document.getElementById('modeChatStatusText');
    var notice = document.getElementById('modeChatOfflineNotice');

    if (dot) {
      dot.className = 'mode-chat-header__status-dot ' +
        (online ? 'mode-chat-header__status-dot--online' : 'mode-chat-header__status-dot--offline');
    }
    if (text) {
      text.textContent = online ? 'Online' : 'Team is offline';
    }
    if (notice) {
      notice.classList.toggle('mode-chat-offline-notice--visible', !online);
    }
  }

  // ── Helpers ────────────────────────────────────────────────────────
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function generateSessionId() {
    var ts = Math.floor(Date.now() / 1000);
    var rand = Math.random().toString(36).substring(2, 8);
    return 'mode-chat-' + ts + '-' + rand;
  }

  function isProductPage() {
    return pageType === 'product' && !!pageUrl;
  }

  function setProductMentionState(nextState) {
    includeProductUrl = !!nextState && isProductPage();

    if (!mentionProductBtn) return;

    mentionProductBtn.classList.toggle('mode-chat-input__mention--active', includeProductUrl);
    mentionProductBtn.setAttribute('aria-pressed', includeProductUrl ? 'true' : 'false');
  }

  function buildOutboundBody(message) {
    if (!includeProductUrl || !isProductPage()) return message;
    if (message.indexOf(pageUrl) !== -1) return message;
    return message + '\n\nProduct page: ' + pageUrl;
  }

  function getResumeSessionFromUrl() {
    try {
      var url = new URL(window.location.href);
      var params = url.searchParams;

      if (params.get('mc_resume') !== '1') return null;

      var restored = {
        sessionId: (params.get('mc_session_id') || '').trim(),
        conversationId: (params.get('mc_conversation_id') || '').trim() || null,
        sessionToken: (params.get('mc_session_token') || '').trim(),
        name: (params.get('mc_name') || '').trim(),
        email: (params.get('mc_email') || '').trim().toLowerCase(),
        vehicle: null,
        createdAt: Date.now()
      };

      if (!restored.sessionId || !restored.sessionToken || !restored.name || !restored.email) {
        return null;
      }

      if (!/^[a-f0-9]{64}$/.test(restored.sessionToken)) {
        return null;
      }

      return restored;
    } catch (e) {
      return null;
    }
  }

  function stripResumeParamsFromUrl() {
    try {
      var url = new URL(window.location.href);

      RESUME_QUERY_KEYS.forEach(function (key) {
        url.searchParams.delete(key);
      });

      var nextUrl = url.pathname + (url.search || '') + (url.hash || '');
      window.history.replaceState({}, document.title, nextUrl);
    } catch (e) {
      // Best-effort only
    }
  }

  // ── localStorage session ───────────────────────────────────────────
  function loadSession() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (Date.now() - data.createdAt > CONFIG.SESSION_TTL) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
  }

  function saveSession() {
    if (session) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    }
  }

  function clearSession() {
    session = null;
    localStorage.removeItem(STORAGE_KEY);
  }

  // ── Message history ────────────────────────────────────────────────
  function fetchHistory(onDone) {
    if (!session || !session.conversationId) { onDone(); return; }

    fetch(CONFIG.WORKER_URL + '/mode-chat-history', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Mode-Chat-Session': session.sessionToken
      },
      body: JSON.stringify({
        sessionId: session.sessionId,
        conversationId: session.conversationId,
        email: session.email
      })
    })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      if (data && data.messages && data.messages.length) {
        data.messages.forEach(function (msg) {
          var isAutoReply = msg.body && msg.body.indexOf('[Auto-reply]') === 0;
          if (msg.direction === 'outbound' && !isAutoReply) {
            renderMessage(msg.body, null, 'user');
          } else {
            var body = isAutoReply ? msg.body.replace(/^\[Auto-reply\]\s*/, '') : msg.body;
            renderMessage(body, msg.senderName || 'MODE', 'agent');
          }
        });
      }
    })
    .catch(function () { /* best-effort — silently skip on error */ })
    .finally(onDone);
  }

  // ── UI state management ────────────────────────────────────────────
  function openPanel() {
    updateOnlineStatus();
    panel.classList.add('mode-chat-panel--open');
    bubble.style.display = 'none';
    bubble.classList.remove('mode-chat-bubble--notification');
    // Customer opened the panel — flush any held read receipts
    if (pendingReadReceiptUrls.length) {
      pendingReadReceiptUrls.forEach(sendReadReceipt);
      pendingReadReceiptUrls = [];
    }
  }

  function closePanel() {
    panel.classList.remove('mode-chat-panel--open');
    bubble.style.display = 'flex';
  }

  function setBackBtn(visible) {
    if (!chatBackBtn) return;
    chatBackBtn.classList.toggle('mode-chat-header__back--visible', visible);
  }

  function showInstantAnswersOverlay() {
    instantAnswersPanel.style.display = 'flex';
  }

  function hideInstantAnswersOverlay() {
    instantAnswersPanel.style.display = 'none';
  }

  function showChat(hasHistory) {
    form.style.display = 'none';
    msgArea.style.display = 'flex';
    inputBar.style.display = 'flex';
    if (instantAnswersData.length) {
      renderInstantAnswers();
      instantAnswersActive = true;
      setBackBtn(true);
      if (!hasHistory) {
        showInstantAnswersOverlay();
      } else {
        hideInstantAnswersOverlay();
      }
    } else {
      instantAnswersActive = false;
      setBackBtn(false);
      hideInstantAnswersOverlay();
    }
    inputField.focus();
  }

  function showForm() {
    form.style.display = 'flex';
    msgArea.style.display = 'none';
    inputBar.style.display = 'none';
    instantAnswersActive = false;
    setBackBtn(false);
    hideInstantAnswersOverlay();
  }

  function renderInstantAnswers() {
    if (!instantAnswersData.length || !instantAnswersList) return;
    instantAnswersList.innerHTML = '';
    instantAnswersData.forEach(function (item) {
      var btn = document.createElement('button');
      btn.className = 'mode-instant-answers__btn';
      btn.type = 'button';
      btn.textContent = item.q;
      btn.addEventListener('click', function () {
        hideInstantAnswersOverlay();
        sendInstantAnswer(item.q, item.a);
      });
      instantAnswersList.appendChild(btn);
    });
  }

  function sendInstantAnswer(question, answer) {
    // Render question + answer locally immediately
    renderMessage(question, null, 'user');
    renderMessage(answer, 'MODE', 'agent');

    // POST the question to Missive, then POST the auto-reply once we have conversationId
    var payload = {
      sessionId: session.sessionId,
      conversationId: session.conversationId || null,
      name: session.name,
      email: session.email,
      body: question,
      productUrl: null,
      isFirstMessage: false
    };
    fetch(CONFIG.WORKER_URL + '/mode-chat-inbound', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Mode-Chat-Session': session.sessionToken
      },
      body: JSON.stringify(payload)
    })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      if (data && data.conversationId && !session.conversationId) {
        session.conversationId = data.conversationId;
        saveSession();
      }
      // Now send the auto-reply with the correct conversationId
      return fetch(CONFIG.WORKER_URL + '/mode-chat-inbound', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Mode-Chat-Session': session.sessionToken
        },
        body: JSON.stringify({
          sessionId: session.sessionId,
          conversationId: session.conversationId || null,
          name: session.name,
          email: session.email,
          body: '[Auto-reply] ' + answer,
          productUrl: null,
          isFirstMessage: false
        })
      });
    })
    .catch(function () { /* best-effort */ });
  }

  // ── Message rendering ──────────────────────────────────────────────
  function renderMessage(text, sender, type) {
    var msg = document.createElement('div');
    msg.className = 'mode-chat-msg mode-chat-msg--' + type;

    if (type === 'agent' && sender) {
      var nameEl = document.createElement('div');
      nameEl.className = 'mode-chat-msg__name';
      nameEl.textContent = sender;
      msg.appendChild(nameEl);
    }

    var body = document.createElement('div');
    var urlPattern = /(https?:\/\/[^\s]+)/g;
    var parts = text.split(urlPattern);
    parts.forEach(function (part) {
      if (urlPattern.test(part)) {
        var a = document.createElement('a');
        a.href = part;
        a.textContent = part;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        body.appendChild(a);
      } else {
        body.appendChild(document.createTextNode(part));
      }
      urlPattern.lastIndex = 0;
    });
    msg.appendChild(body);

    msgArea.appendChild(msg);
    msgArea.scrollTop = msgArea.scrollHeight;
  }

  function renderSystemMessage(text) {
    var msg = document.createElement('div');
    msg.className = 'mode-chat-msg mode-chat-msg--system';
    msg.textContent = text;
    msgArea.appendChild(msg);
    msgArea.scrollTop = msgArea.scrollHeight;
  }

  function renderError(text) {
    var msg = document.createElement('div');
    msg.className = 'mode-chat-msg mode-chat-msg--error';
    msg.textContent = text;
    msgArea.appendChild(msg);
    msgArea.scrollTop = msgArea.scrollHeight;
  }

  function disableInput() {
    inputField.disabled = true;
    sendBtn.disabled = true;
    inputField.placeholder = 'Conversation closed';
  }

  // ── Pusher connection ──────────────────────────────────────────────
  function connectPusher() {
    if (!session || !window.Pusher) return;

    pusher = new window.Pusher(CONFIG.PUSHER_KEY, {
      cluster: CONFIG.PUSHER_CLUSTER,
      authEndpoint: CONFIG.WORKER_URL + '/mode-chat-pusher-auth',
      auth: {
        headers: {
          'X-Mode-Chat-Session': session.sessionToken
        }
      }
    });

    channel = pusher.subscribe('private-mode-chat-' + session.sessionId);

    channel.bind('agent-reply', function (data) {
      renderMessage(data.body, data.agentName || 'MODE', 'agent');

      if (panel.classList.contains('mode-chat-panel--open')) {
        if (data.readReceiptUrl) {
          sendReadReceipt(data.readReceiptUrl);
        }
      } else {
        // Hold the receipt until the customer opens the panel
        if (data.readReceiptUrl) {
          pendingReadReceiptUrls.push(data.readReceiptUrl);
        }
        bubble.classList.add('mode-chat-bubble--notification');
      }
    });

    channel.bind('conversation-closed', function () {
      renderSystemMessage('This conversation has been closed.');
      disableInput();
    });
  }

  function sendReadReceipt(readReceiptUrl) {
    // Fire-and-forget — no need to wait for response
    fetch(CONFIG.WORKER_URL + '/mode-chat-read', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        readReceiptUrl: readReceiptUrl,
        sessionId: session.sessionId
      })
    }).catch(function () {
      // Silently ignore — worst case: visitor gets a follow-up email
    });
  }

  // ── API calls ──────────────────────────────────────────────────────
  function sendMessage(text) {
    if (sending || !session || !text.trim()) return;

    var message = text.trim();
    var outboundBody = buildOutboundBody(message);
    sending = true;
    sendBtn.disabled = true;

    // Optimistic render
    renderMessage(message, null, 'user');
    inputField.value = '';
    autoResize();

    var payload = {
      sessionId: session.sessionId,
      conversationId: session.conversationId || null,
      name: session.name,
      email: session.email,
      body: outboundBody,
      productUrl: includeProductUrl && isProductPage() ? pageUrl : null,
      isFirstMessage: false
    };

    fetch(CONFIG.WORKER_URL + '/mode-chat-inbound', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Mode-Chat-Session': session.sessionToken
      },
      body: JSON.stringify(payload)
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Send failed');
      return r.json();
    })
    .then(function (data) {
      if (data.conversationId && !session.conversationId) {
        session.conversationId = data.conversationId;
        saveSession();
      }
      setProductMentionState(false);
    })
    .catch(function () {
      renderError('Failed to send — check your connection and try again.');
    })
    .finally(function () {
      sending = false;
      sendBtn.disabled = false;
      inputField.focus();
    });
  }

  function submitForm(e) {
    e.preventDefault();
    formError.textContent = '';

    var name    = document.getElementById('modeChatName').value.trim();
    var email   = document.getElementById('modeChatEmail').value.trim();
    var vehicle = document.getElementById('modeChatVehicle').value.trim();
    var consent = document.getElementById('modeChatConsent').checked;

    if (!name || !email) {
      formError.textContent = 'Name and email are required.';
      return;
    }

    // Basic email validation
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      formError.textContent = 'Please enter a valid email address.';
      return;
    }

    var submitBtn = form.querySelector('.mode-chat-form__submit');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Connecting...';

    var sessionId = generateSessionId();

    var payload = {
      sessionId: sessionId,
      name: name,
      email: email,
      vehicle: vehicle || null,
      marketingConsent: consent,
      body: vehicle
        ? 'Chat started. Vehicle: ' + vehicle
        : 'Chat started.',
      isFirstMessage: true
    };

    fetch(CONFIG.WORKER_URL + '/mode-chat-inbound', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Setup failed');
      return r.json();
    })
    .then(function (data) {
      session = {
        sessionId: sessionId,
        conversationId: data.conversationId || null,
        sessionToken: data.sessionToken,
        name: name,
        email: email,
        vehicle: vehicle || null,
        createdAt: Date.now()
      };
      saveSession();
      showChat();
      connectPusher();
      renderSystemMessage('Connected — the team typically replies within a few minutes.');
    })
    .catch(function () {
      formError.textContent = 'Could not connect. Please try again.';
      submitBtn.disabled = false;
      submitBtn.textContent = 'Start chat';
    });
  }

  // ── Auto-resize textarea ───────────────────────────────────────────
  function autoResize() {
    inputField.style.height = 'auto';
    inputField.style.height = Math.min(inputField.scrollHeight, 80) + 'px';
  }

  // ── Event binding ──────────────────────────────────────────────────
  bubble.addEventListener('click', function () {
    openPanel();
    if (session) {
      inputField.focus();
    }
  });

  minimiseBtn.addEventListener('click', closePanel);

  if (instantAnswersMinimise) {
    instantAnswersMinimise.addEventListener('click', closePanel);
  }

  if (chatBackBtn) {
    chatBackBtn.addEventListener('click', function () {
      if (instantAnswersActive) {
        showInstantAnswersOverlay();
      }
    });
  }

  if (instantAnswersGoChat) {
    instantAnswersGoChat.addEventListener('click', function () {
      hideInstantAnswersOverlay();
      inputField.focus();
    });
  }

  form.addEventListener('submit', submitForm);

  sendBtn.addEventListener('click', function () {
    sendMessage(inputField.value);
  });

  if (mentionProductBtn) {
    mentionProductBtn.addEventListener('click', function () {
      setProductMentionState(!includeProductUrl);
      inputField.focus();
    });
  }

  inputField.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage(inputField.value);
    }
  });

  inputField.addEventListener('input', autoResize);

  // ── Init ───────────────────────────────────────────────────────────
  var resumedFromUrl = false;
  var resumeSession = getResumeSessionFromUrl();

  if (resumeSession) {
    session = resumeSession;
    saveSession();
    stripResumeParamsFromUrl();
    resumedFromUrl = true;
  } else {
    session = loadSession();
  }

  if (session && session.sessionToken) {
    showChat(true);
    fetchHistory(function () {
      connectPusher();
      if (resumedFromUrl) {
        openPanel();
        renderSystemMessage('Your conversation has been reopened. Continue below.');
      } else {
        renderSystemMessage('Welcome back, ' + session.name + '. Continue your conversation below.');
      }
    });
  } else {
    showForm();
  }

  updateOnlineStatus();

  // ── Debug API ──────────────────────────────────────────────────────
  setProductMentionState(false);

  window.MODEChat = {
    getSession: function () { return session; },
    clearSession: function () {
      clearSession();
      showForm();
      setProductMentionState(false);
      msgArea.innerHTML = '';
      instantAnswersActive = false;
      setBackBtn(false);
      hideInstantAnswersOverlay();
      if (instantAnswersList) instantAnswersList.innerHTML = '';
    }
  };

})();
